import {IdName} from '@domain/id-name';

export class Thread {
  private _yarnCount: number;
  private _spaceDye: boolean;
  private _rawMaterialView: IdName;

  public constructor(yarnCount: number, spaceDye: boolean, rawMaterialView: IdName) {
    this._yarnCount = yarnCount;
    this._spaceDye = spaceDye;
    this._rawMaterialView = rawMaterialView;
  }

  public get yarnCount(): number {
    return this._yarnCount;
  }

  public get spaceDye(): boolean {
    return this._spaceDye;
  }

  public get rawMaterialView(): IdName {
    return this._rawMaterialView;
  }
}
